import { useAppState } from '@/hooks/useAppState';
import { DIALOGS } from '@/constants/dialogs';
import { SearchIcon } from '@/icons';
import { classes } from './utils';

export default function SearchButton() {
  const { onOpenDialog } = useAppState();

  return (
    <button
      type="button"
      className={classes.button}
      onClick={() => onOpenDialog(DIALOGS.SEARCH)}>
      <SearchIcon size={16} className={classes.icon} />
      <span className={classes.placeholder}>
        Search companies, investors...
      </span>
    </button>
  );
}
